module.exports = __webpack_public_path__ + "static/img/drawTips.ec5a8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drawTips.png
// module id = OUvl
// module chunks = 1